import { TermFees } from "./TermFees";
export class FeesPerTerm {
    _termFees;
    constructor(params) {
        this.termFees = params.termFees;
    }
    static empty() {
        return new FeesPerTerm({ termFees: [] });
    }
    get termFees() {
        return this._termFees;
    }
    get all() {
        return this.termFees;
    }
    set termFees(value) {
        if (!value || value.length === 0) {
            this._termFees = [];
            return;
        }
        // check type and inflate
        this._termFees = value.map((c) => {
            if (c instanceof TermFees) {
                return c;
            }
            return new TermFees(c);
        });
    }
    get json() {
        return this.termFees.map((termFee) => termFee.json);
    }
    updateModelValues() {
        this.termFees.forEach((tf) => tf.fees.forEach((f) => f.updateModelValues()));
    }
    updateJsValues() {
        this.termFees.forEach((tf) => tf.fees.forEach((f) => f.updateJsValues()));
    }
    activateAll() {
        this.termFees.forEach((tf) => tf.fees.forEach((f) => (f.active = true)));
    }
    deactivateAll() {
        this.termFees.forEach((tf) => tf.fees.forEach((f) => (f.active = false)));
    }
    get length() {
        return this.termFees.length;
    }
    getFeesForTerm(termNumber) {
        return this.termFees.find((termFee) => termFee.termNumber === termNumber)?.fees || [];
    }
    addFee(termFee) {
        const termFees = this.termFees.find((termFee) => termFee.termNumber === termFee.termNumber);
        if (termFees) {
            termFee.fees.forEach((fee) => termFees.addFee(fee));
        }
        else {
            this.termFees.push(termFee);
        }
    }
    removeFeeById(feeId) {
        this.termFees.forEach((termFee) => termFee.removeFeeById(feeId));
    }
    removeAllFeesForTerm(termNumber) {
        this.termFees = this.termFees.filter((termFee) => termFee.termNumber !== termNumber);
    }
    get flatFeesPerTerm() {
        return this.termFees.flatMap((termFee) => termFee.flatTermFees);
    }
}
